import React from "react";

// type TestCpnProps = {
//   //
// };

const TestCpn = () => {
  return (
    <div> TestCpn</div >
  )
}

export default TestCpn;
